import React from "react";

import ProductsGroup from "./ProductsGroup/ProductsGroup";

import { useInView } from "react-intersection-observer";
import cs from "classnames";

import "./Products.scss";

const Products = () => {
  const { ref: productTitleRef, inView: productTitleVisibility } = useInView();

  return (
    <div className="Products">
      <div
        ref={productTitleRef}
        className={cs(
          "Products__title",
          productTitleVisibility && "Products__title-animation",
        )}
      >
        Products
      </div>
      <ProductsGroup />
    </div>
  );
};

export default Products;
